import TutorialIndexSummary from "../../Components/tutorial/TutorialModel/TutorialIndexSummary";
import  TutorialContentSummary from '../../Components/tutorial/TutorialModel/TutorialContentSummary';
import TutorialSection from '../../Components/tutorial/TutorialModel/TutorialSection';

const ENV=process.env.REACT_APP_ENV;
const CMS_API_URL=process.env.REACT_APP_CMS_API_URL;
export default class TutorialService
{

   
    constructor() 
    {
        
    }

    /** @returns {Promise<TutorialContentSummary>} */
    async getTutorial(slug)
    {
        
         const response = await fetch(`https://cms.knowledgebuddy.in/api/Tutorial/GetTutorial?slug=${slug}`);
         if (!response.ok) 
            {
            throw new Error(`HTTP error! status: ${response.status}`);
            }

        const result = await response.json();
        if (result.status === "success" && result.data)
            {
                const  tutorialContentSummary = new TutorialContentSummary();

                var data = result.data;
                tutorialContentSummary.TutorialId = data.tutorialId;
                tutorialContentSummary.Title = data.title;
                tutorialContentSummary.Slug = data.slug;
                tutorialContentSummary.Icon = data.icon;
                tutorialContentSummary.TutorialIndexes = data.tutorialIndexes.map(
                    x=> new TutorialIndexSummary(x.linkToSection,x.indexName)
                );

                tutorialContentSummary.TutorialSections = data.tutorialSections.map(

                    x=> new TutorialSection(x.index,x.section)
                );

                return tutorialContentSummary;
            }

            return null;
    
        
    }

     /** @returns {Promise<TutorialCategoryBreifSummary>} */
    async getTutorialBreifSummary()
    {
        let tutorialCategories = [];
        try 
        {
           

            const response = await fetch(`https://cms.knowledgebuddy.in/api/Tutorial/GetTutorials`);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const result = await response.json();
            if (result.status === "success" && result.data && Array.isArray(result.data))
                {
               
                
                for (const category of result.data) 
                {
                    let categorySummary = {
                        index: category.index,
                        categoryid: category.categoryid,
                        category: category.category,
                        icon: category.icon,
                        isActive: category.isActive,
                        tutorials: []
                    };

                    if (Array.isArray(category.tutorials)) {
                        for (const tut of category.tutorials) {
                            let tutorialSummary = {
                                index: tut.index,
                                tutorialId: tut.tutorialId,
                                isActive: tut.isActive,
                                title: tut.title,
                                slug:tut.slug,
                                icon: tut.icon,
                                redirectionUrl: tut.redirectionUrl,
                                description: tut.description,
                                author: tut.author
                            };
                            categorySummary.tutorials.push(tutorialSummary);
                        }
                    }

                    tutorialCategories.push(categorySummary);
                }
                return tutorialCategories;


                }else
                {
                    console.warn("API returned invalid data, using fallback navigation items");
                }

        }catch(error)
        {


        }
        return tutorialCategories;
    }
}